import PropTypes from "prop-types";
import classNames from "classnames";
import { FormControl } from "components/templates";
import { Select } from "../Inputs/";

const prefix = "m-form-select";

const FormSelect = ({
  className,
  disabled = false,
  label,
  name,
  onChange = () => {},
  options,
  readOnly = false,
  reverse = false,
  size,
  selectprops = {},
  value,
  ...props
}) => {

  const classForComponent = classNames(prefix, {
    [className]: className,
    "--reverse": reverse
  });

  return (
    <FormControl
      className={classForComponent}
      labelProps={{
        content: label,
        size
      }}
      content={
        <Select
          disabled={disabled}
          name={name}
          onChange={onChange}
          options={options}
          readOnly={readOnly}
          size={size}
          value={value}
          {...selectprops}
        />
      }
      {...props}
    />
  );
};

FormSelect.propTypes = {
  disabled: PropTypes.bool,
  inputprops: PropTypes.object,
  onChange: PropTypes.func,
  reverse: PropTypes.bool
};

export default FormSelect;
